import { toast } from 'react-toastify';
import {API2} from './api';

export async function getExpertShop() {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().get(`/experts/${expertId}/shops`);
    return response?.result?.data;
    
  }


  export async function createShop({phoneNumber}) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().post(`/experts/${expertId}/shops`,{phoneNumber:phoneNumber});
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }

  export async function changeShopInfo(body) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().put(`/experts/${expertId}/shops`,body);
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }

  export async function changeCategoryInfo({body,categoryId}) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().put(`/experts/${expertId}/shops/category/${categoryId}`,body);
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }
  export async function createCategory(body) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().post(`/experts/${expertId}/shops/category`,body);
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }
  export async function createGoods(body) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().post(`/experts/${expertId}/shops/goods`,body);
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }

  export async function editGoodInfo({title,description,saleable,categoryId,images,goodId}) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().put(`/experts/${expertId}/shops/goods/${goodId}`,{title:title,description:description,saleable:saleable,categoryId:categoryId,images:images});
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }

  export async function deleteGoods(goodId) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().delete(`/experts/${expertId}/shops/goods/${goodId}`);
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }

  export async function deleteModifiedUpdate(goodId) {
    const expertId = JSON.parse(localStorage.getItem("profile"))?.uid;
    const response = await API2().delete(`/experts/${expertId}/shops/goods-updates/${goodId}`);
    if(response){
      const sucsses = response?.result?.message;
      toast.success(sucsses);
      return response;
    }else{
      throw Error()
    }
  }